import { VFlex } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VFlex,{staticClass:"d-flex justify-center align-center px-2",attrs:{"xs12":""}},[_c('h1',{staticStyle:{"color":"#9155FD"}},[_vm._v(_vm._s(_vm.displayTime))])])
}
var staticRenderFns = []

export { render, staticRenderFns }